<template>
  <div id="app">
    <!-- <navbarSection></navbarSection> -->
    <router-view />
    <!-- <footerSection></footerSection> -->
  </div>
</template>

<script>
// import navbarSection from "./layouts/navbarSection/index.vue";
// import footerSection from "./layouts/footerSection/index.vue";
import axios from "axios";
export default {
  name: "App",
  components: {
    // navbarSection,
    // footerSection
  },
  data() {
    return {
      Article: [],
    };
  },
  async created() {
    axios
      .post("https://giftstore-blog.herokuapp.com/api/user/getUser", {
        userId: window.localStorage.getItem("Giftstore-U"),
      })
      .then((response) => {
        console.log("user info", response);
        this.$store.commit("setUserInfo", response.data.user);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    console.log("this.$store",this.$store);

    await this.$loadScript("./vendor/jquery/jquery-3.2.1.min.js");
    await this.$loadScript("./vendor/animsition/js/animsition.min.js");
    await this.$loadScript("./vendor/bootstrap/js/popper.js");
    await this.$loadScript("./vendor/bootstrap/js/bootstrap.min.js");
    await this.$loadScript("./vendor/select2/select2.min.js");
    // $(".selection-1").select2({
    //   minimumResultsForSearch: 20,
    //   dropdownParent: $("#dropDownSelect1"),
    // });
    await this.$loadScript("./vendor/slick/slick.min.js");
    await this.$loadScript("./js/slick-custom.js");
    await this.$loadScript("./vendor/countdowntime/countdowntime.js");
    await this.$loadScript("./vendor/lightbox2/js/lightbox.min.js");
    await this.$loadScript("./vendor/sweetalert/sweetalert.min.js");
    await this.$loadScript("./vendor/daterangepicker/moment.min.js");
    await this.$loadScript("./vendor/daterangepicker/daterangepicker.js");
    /*[ No ui ]
		===========================================================*/
    // var filterBar = document.getElementById("filter-bar");
    // noUiSlider.create(filterBar, {
    //   start: [50, 200],
    //   connect: true,
    //   range: {
    //     min: 50,
    //     max: 200,
    //   },
    // });

    // var skipValues = [
    //   document.getElementById("value-lower"),
    //   document.getElementById("value-upper"),
    // ];

    // filterBar.noUiSlider.on("update", function(values, handle) {
    //   skipValues[handle].innerHTML = Math.round(values[handle]);
    // });

    // $(".block2-btn-addcart").each(function() {
    //   var nameProduct = $(this)
    //     .parent()
    //     .parent()
    //     .parent()
    //     .find(".block2-name")
    //     .html();
    //   $(this).on("click", function() {
    //     swal(nameProduct, "is added to cart !", "success");
    //   });
    // });

    // $(".block2-btn-addwishlist").each(function() {
    //   var nameProduct = $(this)
    //     .parent()
    //     .parent()
    //     .parent()
    //     .find(".block2-name")
    //     .html();
    //   $(this).on("click", function() {
    //     swal(nameProduct, "is added to wishlist !", "success");
    //   });
    // });

    await this.$loadScript("./js/main.js");
    // this.consoleTest();
  },
  methods: {
    // consoleTest: function() {
    //   var test = {firstName: "omar", lastName: "mhiri" }
    //   this.$store.commit('setUserInfo',test)
    //   console.log("store", this.$store.getters.getUserInfo);
    // },
  },
};
</script>
